import * as React from 'react';
import { Route, Routes } from '@leagueplatform/routing';
import { CHAT_HISTORY_URLS } from './constants/chat-history-urls.constants';
import { ChatHistoryPage } from './pages/chat-history.page';

export const ChatHistoryRoutes = () => (
  <Routes>
    <Route
      path={CHAT_HISTORY_URLS.chatHistoryPage}
      element={<ChatHistoryPage />}
    />
  </Routes>
);
